import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-rotation-message',
    template: `
        <span class="icon"><i class="theme-mobile"></i></span>
        <span>{{ landscapeMessage }}</span>
        <a class="theme-ex msg-close" (click)="closed()"></a>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RotationMessageComponent {
    private sitecore = inject(Sitecore);

    @HostBinding('class') className = 'rotation-message-container';
    @Output() close = new EventEmitter<void>();

    constructor() {
        this.landscapeMessage = this.sitecore.globalMessages.NoRotationText;
    }

    landscapeMessage: string;

    closed(): void {
        this.close.emit();
    }
}
